var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropoffNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4696_146626)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.0078125,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#484848",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2168 11.8926C9.06999 12.0394 8.87663 12.1128 8.63672 12.1128C8.39681 12.1128 8.20166 12.0394 8.05127 11.8926C7.90446 11.7422 7.83105 11.5452 7.83105 11.3018V5.75342H7.79883L6.66553 6.54297C6.52946 6.63965 6.38623 6.68799 6.23584 6.68799C6.07113 6.68799 5.93506 6.63428 5.82764 6.52686C5.72021 6.41943 5.6665 6.27979 5.6665 6.10791C5.6665 5.868 5.78288 5.66569 6.01562 5.50098L7.55176 4.4375C7.72721 4.31576 7.88656 4.23519 8.02979 4.1958C8.17301 4.15283 8.33594 4.13135 8.51855 4.13135C8.80501 4.13135 9.02881 4.2137 9.18994 4.37842C9.35465 4.53955 9.43701 4.75977 9.43701 5.03906V11.3018C9.43701 11.5452 9.36361 11.7422 9.2168 11.8926Z",
    fill: "#484848",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4696_146626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(-0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropoffNumber);
export default __webpack_public_path__ + "static/media/Dropoff_Number.0fa205346a056a4a49f95d2a712ccf77.svg";
export { ForwardRef as ReactComponent };